<mat-card *ngIf="!loading" class="mcd-card notifications-page-card">
  <mat-card-header class="mcd-card-header notifications-header">
    <div class="notifications-header-title">
      <svg class="header-bell-icon" width="22" height="22" viewBox="0 0 24 24" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15 17H20L18.5951 15.5951C18.2141 15.2141 18 14.6973 18 14.1585V11C18 7.68629 15.3137 5 12 5C8.68629 5 6 7.68629 6 11V14.1585C6 14.6973 5.78595 15.2141 5.40493 15.5951L4 17H9M15 17V18C15 19.6569 13.6569 21 12 21C10.3431 21 9 19.6569 9 18V17M15 17H9"
          stroke="#334155" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      <mat-card-title class="mcd-card-title">Notifications</mat-card-title>
    </div>
  </mat-card-header>

  <mat-card-content class="mcd-card-content notifications-content">
    <!-- Filter Tabs Bar (matching view-all-standards tabs) -->
    <div class="standards-tabs">
      <div class="tab-wrapper" [class.active]="selectedTab === 'all'" (click)="selectTab('all')">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="8" y1="6" x2="21" y2="6"></line>
          <line x1="8" y1="12" x2="21" y2="12"></line>
          <line x1="8" y1="18" x2="21" y2="18"></line>
          <line x1="3" y1="6" x2="3.01" y2="6"></line>
          <line x1="3" y1="12" x2="3.01" y2="12"></line>
          <line x1="3" y1="18" x2="3.01" y2="18"></line>
        </svg>
        <span class="tabCheckbox">All Notifications</span>
      </div>

      <div class="tab-wrapper" [class.active]="selectedTab === 'standard'" (click)="selectTab('standard')">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
          <path d="m9 12 2 2 4-4"></path>
        </svg>
        <span class="tabCheckbox">Standard</span>
      </div>

      <div class="tab-wrapper" [class.active]="selectedTab === 'exception'" (click)="selectTab('exception')">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
          <polyline points="14 2 14 8 20 8"></polyline>
          <line x1="16" y1="13" x2="8" y2="13"></line>
          <line x1="16" y1="17" x2="8" y2="17"></line>
          <polyline points="10 9 9 9 8 9"></polyline>
        </svg>
        <span class="tabCheckbox">Exception</span>
      </div>
    </div>

    <!-- Timeline Notification Groups -->
    <div class="mcd-notifications-container" *ngIf="groupedNotifications.length > 0">
      <div class="timeline-group" *ngFor="let group of groupedNotifications">
        <!-- Date Divider Pill -->
        <div class="timeline-divider">
          <span class="timeline-pill">{{ group.label }}</span>
        </div>

        <!-- Notification Cards in Group -->
        <div class="notification-cards-list">
          <div class="notification-card-item" *ngFor="let item of group.items; let i = index" [class.unread-card]="!item.isSeen"
            (click)="rowSelected(item); addendumService.isCommingFromNotification = true">
            <!-- Avatar Circle -->
            <div class="avatar-circle" [style.background-color]="getAvatarColor(item, i)">
              {{ getSingleInitial(item.notifiedUser) }}
            </div>

            <!-- Main Content Info -->
            <div class="notification-info-body">
              <div class="notification-title-row">
                <span class="notification-main-title">{{ item.message }}</span>
                <span class="notification-by-user" *ngIf="item.notifiedUser">
                  Added by {{ item.notifiedUser }}<ng-container *ngIf="item.notifiedUserRole"> • {{
                    item.notifiedUserRole }}</ng-container>
                </span>
              </div>
              <p class="notification-description" *ngIf="item.description">
                {{ item.description }}
              </p>
            </div>

            <!-- Right Meta & Tag Badge -->
            <div class="notification-right-meta">
              <span class="time-ago-text" [class.is-unread-time]="!item.isSeen">
                <span class="unread-dot" *ngIf="!item.isSeen">• </span>
                {{ getTimeAgo(item.date) }}
              </span>

              <span class="category-tag-badge" [class.tag-exception]="getNotificationCategory(item) === 'Exception'"
                [class.tag-standard]="getNotificationCategory(item) === 'Standard'"
                [class.tag-supplier]="getNotificationCategory(item) === 'Supplier'"
                [class.tag-equipment]="getNotificationCategory(item) === 'Equipment'">
                <!-- SVG Icon for Tag -->
                <svg *ngIf="getNotificationCategory(item) === 'Exception'" width="13" height="13" viewBox="0 0 24 24"
                  fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                  <polyline points="14 2 14 8 20 8" />
                  <line x1="16" y1="13" x2="8" y2="13" />
                  <line x1="16" y1="17" x2="8" y2="17" />
                </svg>
                <svg *ngIf="getNotificationCategory(item) === 'Standard'" width="13" height="13" viewBox="0 0 24 24"
                  fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                  <path d="m9 12 2 2 4-4" />
                </svg>
                <svg *ngIf="getNotificationCategory(item) === 'Supplier'" width="13" height="13" viewBox="0 0 24 24"
                  fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
                <svg *ngIf="getNotificationCategory(item) === 'Equipment'" width="13" height="13" viewBox="0 0 24 24"
                  fill="none" stroke="currentColor" stroke-width="2">
                  <path
                    d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                </svg>

                <span>{{ getNotificationCategory(item) }}</span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer matching view-all-addendums / addendum-list -->
      <div style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          
        " *ngIf="notificationHistory.length > 0">
        <div>
          <div>
            <mat-form-field>
              <mat-select style="
                  padding: 8px 16px;
                  border: 1px solid #dde1e6;
                  border-radius: 4px;
                  background-color: #f8fafb;
                  color: #4d5258;
                  font-weight: 500;
                " [value]="pageSize" name="nOfRows" #items (selectionChange)="selectedItemsPerPageChange(items)">
                <mat-option [value]="item.value" *ngFor="let item of pageSizes">
                  {{ item.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div>
          <div>
            <ngb-pagination class="float-right" [(page)]="page" [pageSize]="pageSize" [maxSize]="4" [rotate]="true"
              [ellipses]="true" [collectionSize]="collectionSize"
              (pageChange)="loadNotificationsForPageChange()"></ngb-pagination>
          </div>
        </div>

        <div style="display: flex; gap: 10px">
          <button class="prevButton" [ngStyle]="{
              border: page == 1 ? '1px solid #E9ECEF' : '1px solid #C1C6CD',
              color: page == 1 ? '#696F77' : '#34393f'
            }" (click)="goToPreviousPage()">
            <img src="/assets/images/leftarrow.svg" />
            Previous
          </button>
          <button class="nextButton" [ngStyle]="{
              border:
                page == totalPages ? '1px solid #E9ECEF' : '1px solid #C1C6CD',
              color: page == totalPages ? '#696F77' : '#34393f'
            }" (click)="goToNextPage()">
            Next
            <img src="/assets/images/rightarrow.svg" />
          </button>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div class="empty-notifications-state" *ngIf="filteredNotifications.length == 0">
      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" stroke-width="1.5">
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
        <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
      </svg>
      <p>No notifications found.</p>
    </div>
  </mat-card-content>
</mat-card>
<app-mcd-loader class="mcd-page-loader" *ngIf="loading"></app-mcd-loader>